module.exports = "<script type=\"text/html\" id=\"propertyeditor\">\n    <!-- ko if: showDisplayNameOnTop -->\n    <label data-bind=\"text:displayName\"></label>\n    <!-- /ko -->\n    <!-- ko template: {name: 'propertyeditor-error', data: $data} -->\n    <!-- /ko -->\n    <!-- ko template: {name: $data.contentTemplateName, data: $data} -->\n    <!-- /ko -->\n</script>";


//////////////////
// WEBPACK FOOTER
// ./src/templates/propertyEditors/propertyeditor.html
// module id = 133
// module chunks = 0